import { useCallback } from 'react';

import PhoneInput from 'dashboard/components/PhoneInput';
import FormMfaCode, { FormMfaCodeData } from 'dashboard/forms/FormMfaCode';
import FormUserPhoneNumber from 'dashboard/forms/FormUserPhoneNumber';
import { FormUserPhoneNumberData } from 'dashboard/forms/FormUserPhoneNumber/FormUserPhoneNumber';
import Spacer from 'design-system/components/Spacer';
import { Heading, Paragraph } from 'design-system/components/Text';

interface SetupMfaPhoneProps {
  phoneNumber: string;
  onSetup: (phoneNumber: string) => Promise<void>;
  onEnable: (code: string) => Promise<void>;
  onResend: () => Promise<void>;
  onCancel: () => void;
  resendMfaPhoneCodeLoading: boolean;
}

const CODE_LENGTH = 6;

const SetupMfaPhone = ({
  phoneNumber,
  onSetup,
  onEnable,
  onResend,
  onCancel,
  resendMfaPhoneCodeLoading,
}: SetupMfaPhoneProps) => {
  const handleSetup = useCallback(
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    ({ 'phone-number': phoneNumber }: FormUserPhoneNumberData) => onSetup(phoneNumber),
    [],
  );
  const handleEnable = useCallback(({ code }: FormMfaCodeData) => onEnable(code), []);

  return (
    <>
      <Heading size='sm'>Phone 2-factor authentication</Heading>

      <Spacer height={2.5} />

      <Paragraph>Add your phone number to receive a verification code.</Paragraph>
      <Paragraph>Carrier rates and fees may apply.</Paragraph>

      <Spacer height={2.5} />

      {phoneNumber == null ? (
        <FormUserPhoneNumber onCancel={onCancel} onSubmit={handleSetup} />
      ) : (
        <>
          <PhoneInput disabled value={phoneNumber} onChange={() => null} />
          <Spacer height={5} />
          <Paragraph>Please enter the verification code we sent you.</Paragraph>
          <Spacer height={2.5} />
          <FormMfaCode
            codeLength={CODE_LENGTH}
            onCancel={onCancel}
            onSubmit={handleEnable}
            onResend={onResend}
            resendLoading={resendMfaPhoneCodeLoading}
          />
        </>
      )}
    </>
  );
};

export default SetupMfaPhone;
